import React from "react";
import ReserveLayout from "../components/ReserveLayout";

const ReservePage = () => {
  return <ReserveLayout />;
};

export default ReservePage;
